export enum StockAreaEnum {
  GENERAL_STOCK = 'general_stock',
  RETURNS_STOCK = 'returns_stock',
}
